export default function waitlistForm() {
    // Show confirmed state when Ghost redirects back after magic link click
    const params = new URLSearchParams(window.location.search);
    if (params.get('action') === 'subscribe' && params.get('success') === 'true') {
        document.querySelectorAll('.tb-home-form, .tb-form').forEach(f => f.style.display = 'none');
        document.querySelectorAll('.tb-form-pending').forEach(el => el.style.display = 'none');
        document.querySelectorAll('.tb-form-confirmed').forEach(el => el.style.display = 'flex');
    }

    document.querySelectorAll('.tb-home-form, .tb-form').forEach(form => {
        form.addEventListener('submit', async (e) => {
            e.preventDefault();

            const input = form.querySelector('input[type="email"]');
            const button = form.querySelector('button[type="submit"]');
            const email = input.value.trim();
            if (!email) return;

            const originalHTML = button.innerHTML;
            button.disabled = true;
            button.innerHTML = 'SENDING…';

            const redirectUrl = window.location.origin + window.location.pathname + '?action=subscribe&success=true';

            try {
                const res = await fetch('/members/api/send-magic-link/', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ email, emailType: 'subscribe', redirectUrl })
                });

                if (res.ok || res.status === 201) {
                    form.style.display = 'none';
                    const pending = form.closest('.tb-form-block')?.querySelector('.tb-form-pending')
                        || document.querySelector('.tb-form-pending');
                    if (pending) pending.style.display = 'flex';
                } else {
                    button.disabled = false;
                    button.innerHTML = originalHTML;
                    showError(form, 'Etwas ist schiefgelaufen. Nochmal versuchen.');
                }
            } catch {
                button.disabled = false;
                button.innerHTML = originalHTML;
                showError(form, 'Keine Verbindung. Nochmal versuchen.');
            }
        });
    });
}

function showError(form, msg) {
    let err = form.querySelector('.tb-form-error');
    if (!err) {
        err = document.createElement('div');
        err.className = 'tb-form-error';
        form.after(err);
    }
    err.textContent = msg;
}
